import { createReducer } from '@reduxjs/toolkit';
import { deleteTokens, setTokens } from '../../../../../services/actions';
export const createTokensReducer = initState => createReducer(initState, b => {
  b.addCase(setTokens, (_, action) => action.payload);
  b.addCase(deleteTokens, () => initState);
});